import ConfirmStudentInfoPage from "./ConfirmStudentInfoPage";

export default ConfirmStudentInfoPage;